import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TopServiceModel } from './model';

export const adapter: EntityAdapter<TopServiceModel> = createEntityAdapter<TopServiceModel>({
  selectId: model => model.id,
});

export interface TopServiceState extends EntityState<TopServiceModel> {
  isLoading?: boolean;
  error?: any;
}

export const initialState: TopServiceState = adapter.getInitialState({
  isLoading: false,
  error: null,
});
